import Vue from 'vue'
import Router from 'vue-router'
import { progressIndicator } from '../libs/progress-indicator'
import {
  Configuration,
  ErrorMessages,
  DefaultSearchCompanyQuery,
  DefaultSearchCorporationQuery,
  DefaultSearchJobQuery,
  DefaultSearchStartingBusinessQuery,
  DefaultAggregateJobQuery,
  perPages,
} from '../constants'

import PublicPage from '../components/PublicPage'
import PrivatePage from '../components/PrivatePage'

import Unauthorized from '../components/Unauthorized'

import SignIn from '../components/SignIn'
import ForgotPassword from '../components/ForgotPassword'
import ResetPassword from '../components/ResetPassword'
import TermsOfService from '../components/TermsOfService'
import MynaviTermsOfService from '../components/MynaviTermsOfService'

import SearchJob from '../components/search/SearchJob'
import SearchGroupingJob from '../components/search/SearchGroupingJob'
import SearchCompany from '../components/search/SearchCompany'
import SearchCorporation from '../components/search/SearchCorporation'
import CorporationDetail from '../components/CorporationDetail'
import SearchMap from '../components/search/SearchMap'
import Aggregation from '../components/Aggregation'
import CsvFile from '../components/s3/CsvFile'
import CompanyDetail from '../components/CompanyDetail'
import SearchConditions from '../components/SearchConditions'
import JobNotificationSettings from '../components/JobNotificationSettings'
import AggJobSearchConditions from '../components/AggJobSearchConditions'
import ExclusionCompanyName from '../components/ExclusionCompanyName'
import InclusionCompanyName from '../components/InclusionCompanyName'
import JobList from '../components/JobList'
import CompanyList from '../components/CompanyList'
import SearchStartingBusiness from '../components/search/SearchStartingBusiness'
import StartingBusinessList from '../components/StartingBusinessList'
import AggregateJob from '../components/aggregate/AggregateJob'
// import Guide from '../components/guide/Guide'
import GuideJobNotificationSettingsOverview from '../components/guide/job-notification-settings/JobNotificationSettings'
import GuideJobNotificationSettings1a from '../components/guide/job-notification-settings/overview/1-a'
import GuideJobNotificationSettings1b from '../components/guide/job-notification-settings/overview/1-b'
import GuideJobNotificationSettings1c from '../components/guide/job-notification-settings/overview/1-c'
import GuideJobNotificationSettings1d from '../components/guide/job-notification-settings/overview/1-d'
import GuideJobNotificationSettings2a from '../components/guide/job-notification-settings/overview/2-a'
import GuideJobNotificationSettings2b from '../components/guide/job-notification-settings/overview/2-b'
import GuideJobNotificationSettings2c from '../components/guide/job-notification-settings/overview/2-c'
import GuideJobNotificationSettings3a from '../components/guide/job-notification-settings/overview/3-a'
import GuideJobNotificationSettings3b from '../components/guide/job-notification-settings/overview/3-b'
import GuideJobNotificationSettings3c from '../components/guide/job-notification-settings/overview/3-c'
import GuideJobNotificationSettings3d from '../components/guide/job-notification-settings/overview/3-d'
import GuideMarketAnalysisOverview from '../components/guide/market-analysis/MarketAnalysis'
import GuideMarketAnalysis1a from '../components/guide/market-analysis/overview/1-a'
import GuideMarketAnalysis1b from '../components/guide/market-analysis/overview/1-b'
import GuideMarketAnalysis1c from '../components/guide/market-analysis/overview/1-c'
import GuideMarketAnalysis1d from '../components/guide/market-analysis/overview/1-d'
import GuideMarketAnalysis1e from '../components/guide/market-analysis/overview/1-e'
import GuideMarketAnalysis2a from '../components/guide/market-analysis/overview/2-a'
import GuideMarketAnalysis2b from '../components/guide/market-analysis/overview/2-b'
import GuideMarketAnalysis2c from '../components/guide/market-analysis/overview/2-c'
import GuideMarketAnalysis2d from '../components/guide/market-analysis/overview/2-d'
import GuideMarketAnalysis3a from '../components/guide/market-analysis/overview/3-a'
import GuideMarketAnalysis3b from '../components/guide/market-analysis/overview/3-b'
import GuideMarketAnalysis3c from '../components/guide/market-analysis/overview/3-c'
import GuideMarketAnalysis3d from '../components/guide/market-analysis/overview/3-d'
import GuideMarketAnalysis3e from '../components/guide/market-analysis/overview/3-e'

import News from '../components/News'


Vue.use(Router)

// モバイル判定
const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

const routerConfiguration = {
  mode: 'history',
  routes: [
    {
      path: '/',
      component: PublicPage,
      children: [
        {
          path: 'signin',
          name: 'SignIn',
          component: SignIn,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('session/filterSignedInUser'),
            ],
            rootComponentClasses: ['static'],
            titleSuffix: 'ログイン',
          },
        },
        {
          path: 'forgot_password',
          name: 'ForgotPassword',
          component: ForgotPassword,
          meta: {
            rootComponentClasses: ['static'],
            titleSuffix: 'パスワード再設定',
          },
        },
        {
          path: 'reset_password',
          name: 'ResetPassword',
          component: ResetPassword,
          meta: {
            rootComponentClasses: ['static'],
            titleSuffix: 'パスワード再設定',
          },
        },
        {
          path: 'terms_of_service',
          name: 'TermsOfService',
          component: TermsOfService,
          meta: {
            titleSuffix: '利用規約',
          },
        },
        {
          path: 'mynavi_terms_of_service',
          name: 'MynaviTermsOfService',
          component: MynaviTermsOfService,
          meta: {
            titleSuffix: '利用規約',
          },
        },
      ],
    },
    {
      path: '/',
      component: PrivatePage,
      meta: {
        pre: [
          async ({ store }) => store.dispatch('session/checkAuthorization'),
        ],
        requiresAuth: true,
      },
      children: [
        {
          path: '/search/job',
          name: 'SearchJob',
          component: SearchJob,
          meta: {
            scrollHiddenHeaderSP: true,
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/search/grouping-job',
          name: 'SearchGroupingJob',
          component: SearchGroupingJob,
          meta: {
            scrollHiddenHeaderSP: true,
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/search/haken',
          name: 'SearchHaken',
          component: SearchJob,
          meta: {
            scrollHiddenHeaderSP: true,
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/search/grouping-haken',
          name: 'SearchGroupingHaken',
          component: SearchGroupingJob,
          meta: {
            scrollHiddenHeaderSP: true,
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/search/company',
          name: 'SearchCompany',
          component: SearchCompany,
          meta: {
            scrollHiddenHeaderSP: true,
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/search/map',
          name: 'SearchMap',
          component: SearchMap,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/aggregation',
          name: 'Aggregation',
          component: Aggregation,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/search/corporation',
          name: 'SearchCorporation',
          component: SearchCorporation,
          meta: {
            scrollHiddenHeaderSP: true,
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/corporation',
          name: 'CorporationDetail',
          component: CorporationDetail,
          meta: {
            scrollHiddenHeaderSP: true,
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/csv_file',
          name: 'CsvFile',
          component: CsvFile,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkAdmin'),
            ],
            role: 'basic',
          },
        },
        {
          path: '/company',
          name: 'CompanyDetail',
          component: CompanyDetail,
          meta: {
            scrollHiddenHeaderSP: true,
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: 'search_conditions',
          name: 'SearchConditions',
          component: SearchConditions,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: 'agg_job_search_conditions',
          name: 'AggJobSearchConditions',
          component: AggJobSearchConditions,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: 'job_notification_settings',
          name: 'JobNotificationSettings',
          component: JobNotificationSettings,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: 'exclusion_company_name',
          name: 'ExclusionCompanyName',
          component: ExclusionCompanyName,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: 'inclusion_company_name',
          name: 'InclusionCompanyName',
          component: InclusionCompanyName,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: 'job_list',
          name: 'JobList',
          component: JobList,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: 'company_list',
          name: 'CompanyList',
          component: CompanyList,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/search/starting_business',
          name: 'SearchStartingBusiness',
          component: SearchStartingBusiness,
          meta: {
            scrollHiddenHeaderSP: true,
            pre: [
              async ({ store }) => store.dispatch('user/checkStartingBusiness'),
            ],
          },
        },
        {
          path: 'starting_business_list',
          name: 'StartingBusinessList',
          component: StartingBusinessList,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkStartingBusiness'),
            ],
          },
        },
        {
          path: 'aggregate/job',
          name: 'AggregateJob',
          component: AggregateJob,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        // {
        //   path: '/guide',
        //   name: 'Guide',
        //   component: Guide,
        //   meta: {
        //     pre: [
        //       async ({ store }) => store.dispatch('user/checkHasBasic'),
        //     ],
        //   },
        // },
        {
          path: '/guide/job_notification_settings',
          name: 'GuideJobNotificationSettingsOverview',
          component: GuideJobNotificationSettingsOverview,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/job_notification_settings/1-a',
          name: 'GuideJobNotificationSettings1a',
          component: GuideJobNotificationSettings1a,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/job_notification_settings/1-b',
          name: 'GuideJobNotificationSettings1b',
          component: GuideJobNotificationSettings1b,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/job_notification_settings/1-c',
          name: 'GuideJobNotificationSettings1c',
          component: GuideJobNotificationSettings1c,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/job_notification_settings/1-d',
          name: 'GuideJobNotificationSettings1d',
          component: GuideJobNotificationSettings1d,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/job_notification_settings/2-a',
          name: 'GuideJobNotificationSettings2a',
          component: GuideJobNotificationSettings2a,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/job_notification_settings/2-b',
          name: 'GuideJobNotificationSettings2b',
          component: GuideJobNotificationSettings2b,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/job_notification_settings/2-c',
          name: 'GuideJobNotificationSettings2c',
          component: GuideJobNotificationSettings2c,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/job_notification_settings/3-a',
          name: 'GuideJobNotificationSettings3a',
          component: GuideJobNotificationSettings3a,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/job_notification_settings/3-b',
          name: 'GuideJobNotificationSettings3b',
          component: GuideJobNotificationSettings3b,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/job_notification_settings/3-c',
          name: 'GuideJobNotificationSettings3c',
          component: GuideJobNotificationSettings3c,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/job_notification_settings/3-d',
          name: 'GuideJobNotificationSettings3d',
          component: GuideJobNotificationSettings3d,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/market_analysis',
          name: 'GuideMarketAnalysisOverview',
          component: GuideMarketAnalysisOverview,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/market_analysis/1-a',
          name: 'GuideMarketAnalysis1a',
          component: GuideMarketAnalysis1a,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/market_analysis/1-b',
          name: 'GuideMarketAnalysis1b',
          component: GuideMarketAnalysis1b,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/market_analysis/1-c',
          name: 'GuideMarketAnalysis1c',
          component: GuideMarketAnalysis1c,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/market_analysis/1-d',
          name: 'GuideMarketAnalysis1d',
          component: GuideMarketAnalysis1d,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/market_analysis/1-e',
          name: 'GuideMarketAnalysis1e',
          component: GuideMarketAnalysis1e,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/market_analysis/2-a',
          name: 'GuideMarketAnalysis2a',
          component: GuideMarketAnalysis2a,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/market_analysis/2-b',
          name: 'GuideMarketAnalysis2b',
          component: GuideMarketAnalysis2b,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/market_analysis/2-c',
          name: 'GuideMarketAnalysis2c',
          component: GuideMarketAnalysis2c,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/market_analysis/2-d',
          name: 'GuideMarketAnalysis2d',
          component: GuideMarketAnalysis2d,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/market_analysis/3-a',
          name: 'GuideMarketAnalysis3a',
          component: GuideMarketAnalysis3a,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/market_analysis/3-b',
          name: 'GuideMarketAnalysis3b',
          component: GuideMarketAnalysis3b,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/market_analysis/3-c',
          name: 'GuideMarketAnalysis3c',
          component: GuideMarketAnalysis3c,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/market_analysis/3-d',
          name: 'GuideMarketAnalysis3d',
          component: GuideMarketAnalysis3d,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/guide/market_analysis/3-e',
          name: 'GuideMarketAnalysis3e',
          component: GuideMarketAnalysis3e,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: 'news',
          name: 'News',
          component: News,
          meta: {
            pre: [
              async ({ store }) => store.dispatch('user/checkHasBasic'),
            ],
          },
        },
        {
          path: '/unauthorized',
          name: 'Unauthorized',
          component: Unauthorized,
        },
      ],
    },
  ],
}

export default function createRouter ({ store }) {
  const router = new Router(routerConfiguration)

  const isHiddenPage = (route) => {
    const hiddenPages = [
      '/guide',
      '/guide/job_notification_settings',
      '/guide/job_notification_settings/1-a',
      '/guide/job_notification_settings/1-b',
      '/guide/job_notification_settings/1-c',
      '/guide/job_notification_settings/1-d',
      '/guide/job_notification_settings/2-a',
      '/guide/job_notification_settings/2-b',
      '/guide/job_notification_settings/2-c',
      '/guide/job_notification_settings/3-a',
      '/guide/job_notification_settings/3-b',
      '/guide/job_notification_settings/3-c',
      '/guide/job_notification_settings/3-d',
      '/guide/market_analysis',
      '/guide/market_analysis/1-a',
      '/guide/market_analysis/1-b',
      '/guide/market_analysis/1-c',
      '/guide/market_analysis/1-d',
      '/guide/market_analysis/1-e',
      '/guide/market_analysis/2-a',
      '/guide/market_analysis/2-b',
      '/guide/market_analysis/2-c',
      '/guide/market_analysis/2-d',
      '/guide/market_analysis/3-a',
      '/guide/market_analysis/3-b',
      '/guide/market_analysis/3-c',
      '/guide/market_analysis/3-d',
      '/guide/market_analysis/3-e',
    ]
    return hiddenPages.includes(route.path)
  }

  router.beforeEach(async (to, from, next) => {
    progressIndicator.start()
    store.commit('common/lockGlobal')

    const { matched } = to
    let nextParam = {}

    try {
      // eslint-disable-next-line
      for (let i = 0, l = matched.length; i < l; i += 1) {
        const {
          components: { default: { asyncData } },
          meta: { pre = [] },
        } = matched[i]

        // eslint-disable-next-line
        for (let ii = 0, ll = pre.length; ii < ll; ii += 1) {
          await pre[ii]({ store, route: to })
        }

        asyncData && await asyncData({ store, route: to })
      }

      store.commit('route/meta', to.meta)
    } catch (e) {
      const errorMessage = e instanceof Array ? e[0].message : e.message
      // エラーメッセージで必要に応じて飛び先を変える
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        console.error(errorMessage)
      }

      // 未認証でログイン必要なページは signin ページに飛ばす
      if (errorMessage === ErrorMessages.NO_AUTHORIZATION) {
        if (to.matched.some(record => record.meta.requiresAuth)) {
          await store.dispatch('session/forceSignOut')
          nextParam = { name: 'SignIn', query: { redirect: to.fullPath } }
        }
        // 求人検索初回表示時にパラメータ付いてないのでつけて再表示する
      } else if (errorMessage === ErrorMessages.HAS_BASIC_FALSE ||
        errorMessage === ErrorMessages.HAS_STARTING_BUSINESS_FALSE ||
        errorMessage === ErrorMessages.NOT_ADMIN_USER
      ) {
        nextParam = { name: 'Unauthorized' }
      } else if (errorMessage === ErrorMessages.NO_SIGNIN ||
        errorMessage === ErrorMessages.NOT_ADMIN_USER
      ) {
        const query = {
          ...DefaultSearchJobQuery,
          perPage: String(store.state.user.detail.jobs_per_page),
          page: '1',
          _t: new Date().getTime(),
        }
        nextParam = { name: 'SearchJob', query }
      } else if (errorMessage === ErrorMessages.NO_PARAMETER_SEARCH_JOB) {
        const query = {
          ...DefaultSearchJobQuery,
          perPage: String(store.state.user.detail.jobs_per_page),
          page: '1',
          _t: new Date().getTime(),
        }
        nextParam = { name: to.name, query }
      } else if (errorMessage === ErrorMessages.INVALID_PER_PAGE_SEARCH_JOB) {
        const query = {
          ...to.query,
          perPage: perPages[perPages.length - 1].code,
          page: '1',
          _t: new Date().getTime(),
        }
        nextParam = { name: to.name, query }
      } else if (errorMessage === ErrorMessages.NO_PARAMETER_SEARCH_GROUPING_JOB) {
        // TODO デフォルト値やページ数の渡し方検討
        const query = {
          ...DefaultSearchJobQuery,
          perPage: String(store.state.user.detail.jobs_per_page),
          page: '1',
          _t: new Date().getTime(),
        }
        nextParam = { name: 'SearchGroupingJob', query }
      } else if (errorMessage === ErrorMessages.INVALID_PER_PAGE_SEARCH_GROUPING_JOB) {
        const query = {
          ...to.query,
          perPage: perPages[perPages.length - 1].code,
          page: '1',
          _t: new Date().getTime(),
        }
        nextParam = { name: 'SearchGroupingJob', query }
      } else if (errorMessage === ErrorMessages.NO_PARAMETER_SEARCH_COMPANY) {
        const query = {
          ...DefaultSearchCompanyQuery,
          perPage: String(store.state.user.detail.companies_per_page),
          page: '1',
          _t: new Date().getTime(),
        }
        nextParam = { name: 'SearchCompany', query }
      } else if (errorMessage === ErrorMessages.INVALID_PER_PAGE_SEARCH_COMPANY) {
        const query = {
          ...to.query,
          perPage: perPages[perPages.length - 1].code,
          page: '1',
          _t: new Date().getTime(),
        }
        nextParam = { name: 'SearchCompany', query }
      } else if (errorMessage === ErrorMessages.NO_PARAMETER_SEARCH_CORPORATION) {
        const query = {
          ...DefaultSearchCorporationQuery,
          perPage: String(store.state.user.detail.corporations_per_page),
          page: '1',
          _t: new Date().getTime(),
        }
        nextParam = { name: 'SearchCorporation', query }
      } else if (errorMessage === ErrorMessages.INVALID_PER_PAGE_SEARCH_CORPORATION) {
        const query = {
          ...to.query,
          perPage: perPages[perPages.length - 1].code,
          page: '1',
          _t: new Date().getTime(),
        }
        nextParam = { name: 'SearchCorporation', query }
      } else if (errorMessage === ErrorMessages.NO_PARAMETER_SEARCH_JOB_LIST) {
        const query = {
          assignedTo: String(store.state.user.detail.id),
          perPage: perPages[0].code,
          page: '1',
          _t: new Date().getTime(),
        }
        nextParam = { name: 'JobList', query }
      } else if (errorMessage === ErrorMessages.NO_PARAMETER_SEARCH_STARTING_BUSINESS) {
        const query = {
          ...DefaultSearchStartingBusinessQuery,
          perPage: String(store.state.user.detail.jobs_per_page),
          page: '1',
          _t: new Date().getTime(),
        }
        nextParam = { name: 'SearchStartingBusiness', query }
      } else if (errorMessage === ErrorMessages.INVALID_PER_PAGE_SEARCH_STARTING_BUSINESS) {
        const query = {
          ...to.query,
          perPage: perPages[perPages.length - 1].code,
          page: '1',
          _t: new Date().getTime(),
        }
        nextParam = { name: 'SearchStartingBusiness', query }
      } else if (errorMessage === ErrorMessages.NO_PARAMETER_SEARCH_STARTING_BUSINESS_LIST) {
        const query = {
          assignedTo: String(store.state.user.detail.id),
          perPage: perPages[0].code,
          page: '1',
          _t: new Date().getTime(),
        }
        nextParam = { name: 'StartingBusinessList', query }
      } else if (errorMessage === ErrorMessages.NO_PAGE_PARAMETER) {
        const {
          query: {
            perPage = store.state.user.detail.jobs_per_page || perPages.first.code,
            page = '1',
          },
        } = to
        nextParam = { ...to, query: { ...to.query, perPage, page } }
      } else if (errorMessage === ErrorMessages.NO_PARAMETER_AGGREGATE_JOB) {
        const query = {
          ...DefaultAggregateJobQuery,
        }
        nextParam = { name: 'AggregateJob', query }
      }
    }

    if (to.path === '/') {
      if (!store.state.user.detail.id) {
        window.location.href = Configuration.LP_URL
        return
      } else if (store.state.user.detail.leadle_hr) {
        if (store.state.user.detail.has_basic) {
          nextParam = { name: 'SearchJob' }
        } else if (store.state.user.detail.has_starting_business) {
          nextParam = { name: 'SearchStartingBusiness' }
        } else {
          nextParam = { name: 'Unauthorized' }
        }
      } else {
        nextParam = { name: 'Unauthorized' }
      }
    }
    store.commit('common/forceUnlockGlobal')
    progressIndicator.done()

    if (isMobile() && isHiddenPage(to)) {
      next({ name: 'PrivatePage' })
    } else {
      next(nextParam)
    }
  })

  router.afterEach((to, from) => {
    if (to.path !== from.path) {
      window.gtag('config', Configuration.GA_MEASUREMENT_ID, { page_path: to.path })
    }

    window.scrollTo(0, 0)
  })

  return router
}



// WEBPACK FOOTER //
// ./src/router/index.js